import { Text } from "./text";

class InputsNumber extends Text {
  input: HTMLInputElement;
  max: number;
  min: number;
  init(){
    super.init();
    this.listenMount([this.onMountInputsNumber]);
  }
  onMountInputsNumber(){
    this.input = this.querySelector('input') as HTMLInputElement;
    this.max = parseInt(this.input.getAttribute('max'));
    this.min = parseInt(this.input.getAttribute('min'));
    if(isNaN(this.max)){ this.max = Infinity }
    if(isNaN(this.min)){ this.min = -Infinity }
  }
  getValue(){
    return this.input.value;
  }
  onClickPlus(){
    this.setValue(parseInt(this.getValue()) + 1)
  }
  onClickMinus(){
    this.setValue(parseInt(this.getValue()) - 1)
  }
  setValue(n:number){
    n = Math.max(this.min, Math.min(this.max, n));
    let input:HTMLInputElement = this.querySelector('input') as HTMLInputElement;
    input.value = n.toString();
  }
}

riot.mixin("inputs.number", InputsNumber as riot.TagMixin)
